import { EPermissoes } from '@/enums/ePermissoes';

export default [
  {
    description: 'Usuário',
    path: 'usuario',
    name: 'suporteusuario',
    component: () => import('@/views/suporte/usuario-contrato/Index.vue'),
    goesToMenu: true,
    meta: { permissions: [EPermissoes.Administrativo], escopoObra: 'global' }
  },
  {
    description: 'Inclusão de Usuário',
    path: 'usuario/incluir',
    parent: 'suporteusuario',
    name: 'suporteusuarioinsert',
    component: () => import('@/views/suporte/usuario-contrato/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'suporteusuario',
      permissions: [EPermissoes.Administrativo]
    }
  },
  {
    description: 'Edição de Usuário',
    path: 'usuario/editar/:id',
    parent: 'suporteusuario',
    name: 'suporteusuarioupdate',
    component: () => import('@/views/suporte/usuario-contrato/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'suporteusuario',
      permissions: [EPermissoes.Administrativo]
    }
  },
  {
    description: 'Obras do Usuário',
    path: 'usuario/obras/:id',
    parent: 'suporteusuario',
    name: 'usuarioobra',
    component: () => import('@/views/suporte/usuario-contrato/Obra.vue'),
    meta: {
      parentRouteName: 'suporteusuario',
      permissions: [EPermissoes.Administrativo]
    }
  },
  {
    description: 'Grupo Usuário',
    path: 'grupo-usuarios',
    name: 'grupousuarios',
    component: () => import('@/views/suporte/grupo-usuario/InclusaoEdicao.vue'),
    goesToMenu: true,
    meta: { permissions: [EPermissoes.Administrativo] }
  },
  {
    description: 'Convidar Usuários',
    path: 'convidar-usuario',
    name: 'inviteuser',
    component: () => import('@/views/suporte/convidar-usuario/Index.vue'),
    goesToMenu: true,
    meta: { onlyAdmin: true }
  },
  {
    description: 'Dashboard Usabilidade',
    path: 'dashboard-usabilidade',
    name: 'dashboardusabilidade',
    component: () => import('@/views/suporte/dashboard-usabilidade/Index.vue'),
    goesToMenu: true,
    meta: { onlyAdmin: true, escopoObra: 'global' }
  },
  {
    description: 'Auditoria',
    path: 'auditoria',
    name: 'auditoria',
    component: () => import('@/views/suporte/auditoria/Index.vue'),
    goesToMenu: true,
    meta: { onlyAdmin: true, escopoObra: 'global' }
  },
  {
    description: 'Base Contrato',
    path: 'base-contrato',
    name: 'basecontrato',
    component: () => import('@/views/suporte/base-contrato/Index.vue'),
    goesToMenu: true,
    meta: { onlyAdmin: true, escopoObra: 'global' }
  },
  {
    description: 'Inclusão de Base Contrato',
    path: 'base-contrato/incluir',
    parent: 'basecontrato',
    name: 'basecontratoinsert',
    component: () => import('@/views/suporte/base-contrato/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'basecontrato',
      onlyAdmin: true
    }
  },
  {
    description: 'Edição de Base Contrato',
    path: 'base-contrato/editar/:id',
    parent: 'basecontrato',
    name: 'basecontratoupdate',
    component: () => import('@/views/suporte/base-contrato/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'basecontrato',
      onlyAdmin: true
    }
  },
  {
    description: 'Gerenciador de Tarefas Async',
    path: 'task-manager',
    name: 'taskmanager',
    component: () => import('@/views/suporte/task-manager/Index.vue'),
    goesToMenu: true,
    meta: { onlyAdmin: true, escopoObra: 'global' }
  },
  {
    description: 'Admin Scripts',
    path: 'admin-scripts',
    name: 'adminscripts',
    component: () => import('@/views/suporte/admin-scripts/Index.vue'),
    goesToMenu: true,
    meta: { onlyAdmin: true }
  }
];
